import React, {useState, useEffect} from "react"
import styled from "styled-components"
import Result from "./Result/Result";
const Styled ={
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    BtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column;
        height:200px;
    `,
    Btn:styled.div`
        width:250px;
        height:45px;
        background-color:gold;
        border-radius: 10px;
        display:flex;
        justify-content: center;
        flex-direction:row;
        align-items: center;
        :hover{
            opacity:50%;
        }
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,
}

interface PropsType{
    Points : number;
    setPoints : any;
}
const Banking=(props:PropsType)=>{
    const setPoints = props.setPoints
    const Points = props.Points
    
    const [nextPage, setNextPage] = useState<boolean>(false)
    const [Month, setMonth] = useState<any>([
        "6개월 ~ 12개월 미만",
        "12개월 ~ 24개월 미만",
        "24개월 이상"
    ])
    if(nextPage === false){
        return(
            <Styled.Wrap>
                <Styled.LittleTitleFont>청약통장은 얼마나 납입하셨나요(청약 신청일 기준이에요!)</Styled.LittleTitleFont>
                <Styled.BtnWrap>
                    {Month.map((v:any, index:number)=>{
                        return(
                          <Styled.Btn onClick={()=>{
                                  setPoints(index+1 + Points);
                                  setNextPage(true);
                              }}>
                              <Styled.Fonts>{v}</Styled.Fonts>
                          </Styled.Btn>
                        )
                    })}
                </Styled.BtnWrap>
            </Styled.Wrap>
          )
    }else{
        return(
            <Result 
                setPoints={setPoints}
                Points={Points}
            />
        )
    }
}

export default Banking